import ActionGroup from '../../../../../../layout/forms/action-group';
import BackToAccountButton from '../../../../../navigation/back-to-account-button';
import RichTranslation from '@blueshift-ui/i18n/dist/components/rich-translation';
import useRichTranslation from '@blueshift-ui/i18n/dist/hooks/use-rich-translation';

function RevertConfirmation() {
  const { translate } = useRichTranslation('update_revert_confirmation');

  return (
    <>
      <RichTranslation i18nKey={'revert_confirmation_content'} translator={translate} />

      <ActionGroup>
        <BackToAccountButton />
      </ActionGroup>
    </>
  );
}

export default RevertConfirmation;
